import { STALE_ASSESSMENT_GENERATION_MESSAGE } from '@azymmetric/shared/utils/assessment-recency.util';
import { TooltipComponent } from '@components/core/tooltip.component';
import { cn } from '@lib/utils';
import { FC, PropsWithChildren } from 'react';

type StaleAssessmentTooltipProps = {
  className?: string;
};

/**
 * Wraps a disabled generation affordance so the tooltip still receives pointer
 * events, explaining why only the latest TRL score of a use/domain pair can
 * generate.
 * See docs/iterations/AZ-384/AZ-384.DECISIONS.md (D11).
 */
export const StaleAssessmentTooltip: FC<PropsWithChildren<StaleAssessmentTooltipProps>> = (props) => {
  const { children, className } = props;

  return (
    <TooltipComponent trigger={<span className={cn('cursor-not-allowed', className)}>{children}</span>}>
      {STALE_ASSESSMENT_GENERATION_MESSAGE}
    </TooltipComponent>
  );
};
